import { IconRail } from "@/features/dashboard/components/IconRail";
import { GroupChatToggle } from "./components/GroupChatToggle";

/** Settings shell — same icon rail + teal→navy gradient as the chat dashboard. Hosts the
 *  group-chat opt-in toggle. Routed at /innstillinger (wired by the integration agent). */
export function SettingsPage() {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-[radial-gradient(120%_120%_at_50%_0%,#134e4a_0%,#0a2a2e_42%,#020617_100%)] text-white">
      <IconRail />

      <main className="flex-1 overflow-y-auto px-6 py-10">
        <div className="mx-auto w-full max-w-2xl">
          <h1 className="text-2xl font-semibold">Innstillinger</h1>

          <section className="mt-8">
            <h2 className="text-sm font-semibold uppercase tracking-wide text-teal-200">
              Gruppe-chat
            </h2>
            <div className="mt-3 rounded-2xl border border-white/10 bg-white/5 p-6">
              <GroupChatToggle />
            </div>
          </section>
        </div>
      </main>
    </div>
  );
}
